import React from 'react';

export function DummyRow(props: any) {
  return (
    <div>

    </div>
  );
}